import React from "react";
import { Row, Col } from "react-bootstrap";
import { Form, Field } from "react-final-form";
import arrayMutators from "final-form-arrays";
import { FieldArray } from "react-final-form-arrays";
import { useMutation } from "@apollo/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowClose, faPlusSquare } from "@fortawesome/free-solid-svg-icons";

import Label from "../../reuseableComponents/label/Label";
import { ReactSelectAdapter } from "../../reuseableComponents/forms/ReactSelectAdapter";
import ButtonSubmit from "../../reuseableComponents/buttons/ButtonSubmit";
import ButtonProcessing from "../../reuseableComponents/buttons/ButtonProcessing";
import { GET_FU_EMAIL_DETAILS, UPDATE_FU_EMAIL_DETAILS } from "../../../queries/archiveQrys/secureQrys/fileUploadAdminQrys";

const sendType = [
  { value: "to", label: "to" },
  { value: "cc", label: "cc" },
  { value: "bcc", label: "bcc" }
];
const FileUploadEmailNotificationForm = ({ record, user, staffList, handleClose }) => {
  const [updateFileUploadEmail, updateProps] = useMutation(UPDATE_FU_EMAIL_DETAILS, {
    refetchQueries: [{ query: GET_FU_EMAIL_DETAILS }],
    awaitRefetchQueries: true
  });

  function transformEmailTo(array, recordId) {
    let assignedTo = [];
    array.forEach((element) => {
      console.log(element.staff.label);
      let obj = {
        recordId,
        umdId: element.staff.value,
        email: element.staff.label.split("/").length !== 1 ? element.staff.label.split("/")[1] : element.staff.label,
        sendType: element.sendType.value
      };
      assignedTo.push(obj);
    });
    return assignedTo;
  }

  const onSubmit = (data, form) => {
    let assignedTo;
    if (data.emailTo.length > 0) {
      assignedTo = transformEmailTo(data.emailTo, data.recordId);
    }

    if (record) {
      data = {
        ...data,
        assignedTo,
        active: record.active
      };
      console.log(data);
      updateFileUploadEmail({ variables: data }).then(handleClose);
    } else {
      //add new record
    }
  };

  return (
    <>
      <Row>
        <Col>
          <h3>File Upload Email Notifications</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form
            onSubmit={onSubmit}
            keepDirtyOnReinitialize
            mutators={{
              ...arrayMutators
            }}
            initialValues={
              record
                ? {
                    ...record,
                    updatedBy: user.email,
                    emailTo:
                      record.assignedTo.length > 0
                        ? record.assignedTo.map((r) => ({
                            staff: { value: r.umdId, label: r.email },
                            sendType: { value: r.sendType, label: r.sendType }
                          }))
                        : [{ staff: null, sendType: null }]
                  }
                : {
                    createdBy: user.email,
                    emailTo: [{ staff: null, sendType: null }]
                  }
            }
            render={({
              handleSubmit,
              submitting,
              values,
              form: {
                mutators: { push, pop }
              }
            }) => (
              <form onSubmit={handleSubmit}>
                <Row>
                  <Col>
                    <Label htmlFor='emailSubject' label='Email Subject' required />
                    <Field
                      name='emailSubject'
                      id='emailSubject'
                      component='input'
                      className='form-control mb-4'
                      placeholder='email subject'
                      required
                      aria-required="true"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Label htmlFor='emailMessage' label='Email Message' required />
                    <Field
                      name='emailMessage'
                      id='emailMessage'
                      component='textarea'
                      className='form-control mb-4'
                      placeholder='email message'
                      required
                      aria-required="true"
                    />
                  </Col>
                </Row>
                <FieldArray name='emailTo'>
                  {({ fields }) =>
                    fields.map((name, index) => (
                      <Row key={`${name}.staff`}>
                        <Col>
                          <Label htmlFor={`email-${index}`} label='Who are notifcations sent to?' />{" "}
                          <Field
                            options={staffList}
                            name={`${name}.staff`}
                            inputId={`email-${index}`}
                            component={ReactSelectAdapter}
                            placeholder='Select Staff Member'
                            className='mb-4'
                          />
                        </Col>
                        <Col>
                          <Label htmlFor={`send-type-${index}`} label='Send Type' />{" "}
                          <Field
                            options={sendType}
                            name={`${name}.sendType`}
                            inputId={`send-type-${index}`}
                            component={ReactSelectAdapter}
                            placeholder='To, CC, BCC'
                            className='mb-4'
                          />
                        </Col>
                        <Col lg={2} md={2} key={index} className='m-auto pt-2'>
                          <button
                            type='button'
                            onClick={() => fields.remove(index)}
                            className='align-middle m-2'
                            style={{ cursor: "pointer" }}
                            aria-label='Remove recipient'
                          >
                            <FontAwesomeIcon
                              className='font-icon'
                              icon={faWindowClose}
                              style={{ color: "#d70101", fontSize: "150%" }}
                            />
                          </button>
                          {index === fields.length - 1 ? (
                            <button
                              type='button'
                              onClick={() => push("emailTo", undefined)}
                              className='align-middle m-2'
                              style={{ cursor: "pointer" }}
                              aria-label='Add recipient'
                            >
                              <FontAwesomeIcon
                                className='font-icon'
                                icon={faPlusSquare}
                                style={{ color: "#157995", fontSize: "150%" }}
                              />
                            </button>
                          ) : (
                            ""
                          )}
                        </Col>
                      </Row>
                    ))
                  }
                </FieldArray>
                <Row>
                  <Col>
                    {!updateProps.loading ? (
                      <ButtonSubmit id='ddw-primary' />
                    ) : (
                      <ButtonProcessing id='ddw-primary' disabled />
                    )}
                  </Col>
                </Row>
              </form>
            )}
          />
        </Col>
      </Row>
    </>
  );
};

export default FileUploadEmailNotificationForm;
